module.exports = __webpack_public_path__ + "static/img/9_10006.066aa58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue9/9_10006.jpg
// module id = Z+zO
// module chunks = 7